import React from "react";
import { Provider } from "react-redux";
import UserAvatarInner from "./inner";
import store from "./redux/store";
export default function UserAvatar(props) {
    return (React.createElement(Provider, { store: store },
        React.createElement(UserAvatarInner, { ...props })));
}
